export enum PackageV1Currency {
  EUR = 'EUR',
  YEN = 'YEN',
}
